import { useIntl } from 'react-intl';

import classes from './switcher.module.scss';

type TSwitcher = {
  setSelected: React.Dispatch<React.SetStateAction<'production' | 'sandbox'>>;
  defaultChecked: 'production' | 'sandbox';
};

export const Switcher = ({ setSelected, defaultChecked }: TSwitcher) => {
  const { formatMessage } = useIntl();

  const onChange = (event: any) => {
    if (event?.target?.value) setSelected(event?.target?.value);
  };

  return (
    <div onChange={onChange} className={classes.wrapper}>
      <input
        type="radio"
        name="enviroment"
        value="production"
        id="production"
        data-testId="production"

        className={classes.radio}
        defaultChecked={defaultChecked === 'production'}
        hidden
      />
      <label className={classes.radio_label} htmlFor="production">
        {formatMessage({
          id: 'transaction_log_production',
        })}
      </label>

      {/* <span>|</span>
      <input
        type="radio"
        name="enviroment"
        value="sandbox"
        id="sandbox"
        className={classes.radio}
        defaultChecked={defaultChecked === 'sandbox'}
        hidden
      />
      <label className={classes.radio_label} htmlFor="sandbox">
        {formatMessage({
          id: 'transaction_log_sandbox',
        })}
      </label> */}
    </div>
  );
};
